<template lang='pug'>
div(:class='$style[`cc-question-reply-list`]')
  div(:class='$style[`cc-question-reply-list-left`]')
    router-link(
      role='button'
      tabindex='0'
      aria-label='查看個人檔案'
      :class='$style[`cc-question-reply-avatar`]'
      :to='{ name: `profile-detail`, params: { type: `${replyContainer.user_type}`, id: `${replyContainer.auth_id}` }}')
      div(v-if='replyContainer.user_type === `doctor`' :class='$style[`cc-reply-avatar`]')
        figure(v-if='replyContainer.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
          //- Doctor-Male-Avatar
          img(
            v-if='replyContainer.gender === `0`'
            :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
            width='100%'
            height='100%')
          //- Doctor-Female-Avatar
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(replyContainer.thumbSrc)'
            width='100%'
            height='100%')


      div(v-if='replyContainer.user_type === `normal`' :class='$style[`cc-reply-avatar`]')
        figure(v-if='replyContainer.thumbSrc === `` && !replyContainer.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='replyContainer.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='replyContainer.thumbSrc !== `` && !replyContainer.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='replyContainer.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='replyContainer.thumbSrc === `` && replyContainer.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='replyContainer.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='replyContainer.thumbSrc !== `` && replyContainer.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(replyContainer.thumbSrc)'
            width='100%'
            height='100%')


  div(:class='$style[`cc-question-reply-list-right`]')
    div(:class='$style[`cc-question-li-right-message`]')
      div(v-if='loginStatus && replyContainer.auth_id === `${loginDjangoId}`' :class='$style[`cc-question-li-right-delete`]' @click='handleClickKillReply(replyContainer.id, qId, authorId)')

      div(:class='$style[`cc-question-li-right-message-top`]')
        router-link(
          v-if='replyContainer.user_type === `doctor`'
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-question-li-right-name`]'
          :to='{ name: `profile-detail`, params: { type: `doctor`, id: `${replyContainer.auth_id}` }}')
          span.font-medium.font-doctor-theme {{ `${replyContainer.firstName}${replyContainer.lastName}` }}

        router-link(
          v-else
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-question-li-right-name`]'
          :to='{ name: `profile-detail`, params: { type: `normal`, id: `${replyContainer.auth_id}` }}')
          span.font-medium.font-normal-theme(v-if='!replyContainer.public') {{ `${replyContainer.firstName}${replyContainer.gender === `0` ? `先生` : `小姐`}` }}
          span.font-medium.font-normal-theme(v-else) {{ `${replyContainer.firstName}${replyContainer.lastName}` }}

        div(:class='$style[`cc-question-li-right-date`]') {{ replyContainer.date }}

        div(v-if='loginStatus' :class='$style[`cc-question-li-right-reply-btn`]' @click='handleClickShowReplyInterface')
          i.toggle-icon.default-color.toggle-icon-comment(:class='$style[`ic-like`]')
          span!= '回覆'

      span(v-if='replyContainer.reply && needCollapse' :class='$style[`cc-question-li-right-message-word`]') {{ ellipseQaReply(replyContainer.reply) }}
        span(:class='$style[`cc-question-reply-collapse`]' @click='handleClickCloseCollapse')
          IconOpenArrow(:size='12' :color='`#98a1a1`')
          != '看全部'
      span(v-else-if='replyContainer.reply' :class='$style[`cc-question-li-right-message-word`]') {{ replyContainer.reply }}


    div(v-if='showReplyInterface' :class='$style[`cc-question-li-right-controller`]' v-on-clickaway='handleControllerOnBlur')
      div(:class='$style[`cc-question-li-right-textarea`]')
        div(:class='$style[`cc-question-li-right-interface`]')
          TextAreaer(
            v-model='replyConfig.infoValue'
            title='回覆'
            :autoSize='true'
            :key='`${nextTick}-t`'
            :class='$style[`cc-input-textarea`]'
            :defaultValue='replyConfig.infoValue'
            :emojiButton='true'
            :resetButton='false'
            :placehold='`回覆`'
            :errorValue='checkEmptyStatus.infoError'
            @clearErrorMsg='(value) => {this.checkEmptyStatus.infoError = value[0];}')

      div(:class='$style[`cc-question-li-right-panel`]')
        CheckBox(
          v-model='replyConfig.readRuleValue'
          title='我會遵守規範'
          :errorValue='checkEmptyStatus.readRuleError'
          :labelText='`<a href="${NODE_DOMAIN}/termUsage" target="_blank" rel="noreferrer" title="我會遵守規範">遵守規範</a>`'
          @sendCheckStatus='setRuleCheckBoxStatus'
          @clearErrorMsg="(value) => {this.checkEmptyStatus.readRuleError = value}")
        div(:class='$style[`cc-question-li-right-send`]' @click='handleCheckProgressBeforeSend')!= '送出'

    QuestionSubReply(:key='`${nextTick}-sr`' :qid='replyContainer.q_id' :aaid='replyContainer.id')


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconWrite from '../../icon/Write';
import IconEmoji from '../../icon/Emoji';
import IconOpenArrow from '../../icon/OpenArrow';
import CheckBox from '../common/Checkbox';
import { mixin as clickaway } from 'vue-clickaway';
// import { debounce } from 'debounce';
import QuestionSubReply from './QuestionSubReply';
import TextAreaer from '../common/TextArea';

import {
  getCurrentDate,
  postCreateQaReply,
} from '../../../js/restapi';

export default {
  components: {
    QuestionSubReply,
    IconWrite,
    IconEmoji,
    IconOpenArrow,
    CheckBox,
    TextAreaer,
  },

  mixins: [clickaway],

  props: {
    qId: {
      type: String,
      default: '',
    },

    authorId: {
      type: String,
      default: '',
    },

    replyData: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      showEmoji: false,
      showReplyInterface: false,
      totalSubReplyCount: 0,
      needCollapse: false,

      replyConfig: {
        infoValue: '',
        infoError: false,
        readRuleValue: false,
      },

      checkEmptyStatus: {
        infoError: false,
        readRuleError: false,
      },

      verifyAllPass: true,

      replyContainer: {},
      nextTick: 1,
    };
  },

  created() {
    this.replyContainer = this.replyData;
    this.ellipseQaReply(this.replyData.reply);
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteReplyStatus: 'global/POPDELETE_REPLY_STATUS',
    }),

    ellipseQaReply(text) {
      if (text.length > 200) {
        this.needCollapse = true;
        return `${text.substring(0, 200)}...`;
      }
      return text;
    },

    setRuleCheckBoxStatus(value) {
      // eslint-disable-next-line no-unused-expressions
      value === 'checked' ? this.replyConfig.readRuleValue = true : this.replyConfig.readRuleValue = false;
    },

    handleClickCloseCollapse() {
      this.needCollapse = false;
    },

    handleClickShowReplyInterface() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      this.showReplyInterface = !this.showReplyInterface;
    },

    handleControllerOnBlur() {
      this.showReplyInterface = false;
    },

    handleClickKillReply(aaid, qid, remindId) {
      console.log('handleClickKillReply');
      this.changePopDeleteReplyStatus({
        active: true,
        aaId: `${aaid}`,
        qId: `${qid}`,
        remindId: `${remindId}`,
      });
    },

    handleFormCheckToPass() {
      // this.verifyAllPass = this.$options.data().verifyAllPass;
      this.verifyAllPass = true;

      if (!this.replyConfig.infoValue) {
        this.checkEmptyStatus.infoError = true;
        this.verifyAllPass = false;
      }

      if (!this.replyConfig.readRuleValue) {
        this.checkEmptyStatus.readRuleError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      if (!this.verifyAllPass) {
        return;
      }

      this.showLoading = true;
      this.axiosCreateNewSubReply();
    },

    axiosCreateNewSubReply() {
      getCurrentDate('')
        .then((res) => {
          const PASS_DATA = {
            qid: `${this.replyContainer.q_id}`,
            auth_id: `${this.loginDjangoId}`,
            aaid: `${this.replyContainer.id}`,
            reply: `${this.replyConfig.infoValue}`,
            date: `${res.data}`,
          };
          // const jwtAccess = JSON.parse(this.authJwtToken).a;

          postCreateQaReply('', PASS_DATA, {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
            .then((res) => {
              console.log('新增留言成功!');
              this.replyConfig.infoValue = '';
              this.changePopBoxStatus({
                active: true,
                include: 'sendConfirm',
              });
              this.handleUserAddHp(this.loginDjangoId, '+20');
              setTimeout(() => {
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, this.POP_DURATION);
              this.showReplyInterface = false;
              this.nextTick += 1;
            })
            .catch((err) => {
              console.log('Axios postCreateQaReply Error');
            });
        })
        .catch((err) => {
          console.log('Axios getCurrentDate Error');
        });
    },

    async handleCheckProgressBeforeSend() {
      await this.handleFormCheckToPass();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/questionReply.scss';
</style>
